<template>
    <div class="card">
        <div class="card-content">
            <div class="media">
                <div class="media-content">
                    <a :href="url">{{result.first_name}} {{result.last_name}} | Date of Death: {{result.date_of_death}} | Burial Number: {{result.burial_number}} | Section: {{result.section.name}}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Result",
        props: {
            result: {
                type: Object,
                default: {
                }
            }
        },
        computed: {
            url() {
                return "/record/" + this.result.id
            }
        }
    }
</script>

<style scoped>

</style>